import FundDetailsTabRow from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabRow';
import { DOCUMENTS_FORMATS_MAP } from '@/constants/documentsFormatMap';
import { useI18n } from 'next-localization';
import { useMemo } from 'react';
import { DocumentsType } from 'model/FundDetails';
import { pushDataLayerEvent } from 'hooks/dataLayerPush';

const LiteratureSharedTab = ({ tabData, selectedTab }) => {
  const { t } = useI18n();

  const filteredLiteratureDocuments = useMemo(() => {
    return (
      tabData.find((tab) => t(`${tab.title}`) === selectedTab)?.documents || tabData[0].documents
    );
  }, [tabData, selectedTab, t]);

  const literatureDocuments = useMemo(() => {
    return filteredLiteratureDocuments.map((obj) => {
      const format = DOCUMENTS_FORMATS_MAP[obj.contentType];
      const copiedObj = { ...obj };
      if (typeof window !== 'undefined') {
        const { origin } = window;
        const documentUrl = copiedObj.documentUri;
        copiedObj.documentUri = documentUrl.includes('/api/')
          ? `${origin}${documentUrl}`
          : documentUrl;
      }
      return { ...copiedObj, format };
    });
  }, [filteredLiteratureDocuments]);

  const updateDataLayer = (item: DocumentsType) => {
    if (typeof window !== 'undefined') {
      const origin = window.location.origin;
      pushDataLayerEvent({
        event: 'file_download',
        file_url: item.documentUri.includes('https://')
          ? item.documentUri
          : `${origin}${item.documentUri}`,
        file_name: item.title,
      });
    }
  };

  return (
    <FundDetailsTabRow>
      {literatureDocuments.map((item) => (
        <div key={item.id} style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.3)' }}>
          <a
            href={item.documentUri}
            target="_blank"
            className="text-link d-block py-3"
            style={{ width: 'fit-content' }}
            onClick={() => updateDataLayer(item)}
          >
            {item.title} ({item.format?.toUpperCase() ?? ''})
            <i
              aria-hidden="true"
              className={`bi bi-filetype-${item.format}`}
              style={{ fontSize: '24px', paddingLeft: '8px' }}
            />
            <span className="sr-only">{t('opensInNewWindow')}</span>
          </a>
        </div>
      ))}
    </FundDetailsTabRow>
  );
};

export default LiteratureSharedTab;
